import {OrderableBiobank, OrderableCord, OrderableDonor, OrderWithTrackingsModel} from '@matchsource/models/order';
import {VaccinationModel} from '@matchsource/models/vaccination';
import {SourceTypes, SourceList} from '@matchsource/models/source-shared';

export enum SourceProductType {
  Nmdp = 'NMDP',

  Bmdw = 'BMDW',

  Bmdwd = 'BMDWD',

  Coop = 'COOP',

  Wmda = 'WMDA',

  Mbr = 'MBR',
}

export interface Locus {
  matchGrade1: string;

  sign1: string;

  matchGrade2: string;

  sign2: string;

  matchGradeSign1: string;

  matchGradeSign2: string;
}

export interface SourceBaseInfoModel {
  bpGuid: MsApp.Guid;
  displayGrid: string;
  pid: string;
  emdisCoop: boolean;
  emdisId: string;
  grId: MsApp.Guid;
  guid: MsApp.Guid;
  localId: string;
  nmdp: boolean;
  nmdpId: string;
  productType: string;
  id: MsApp.Guid;
  type: string;
  status: string;
  releaseDate: string;
  availabilityDate: MsApp.DateString;
}

export interface EthnicityRacesModel {
  ethnicityCode: string;
  primaryRaceCode: string;
  raceCodes: string[];
}

export const SOURCE_PRODUCT_TYPE_LIST_MAP: Record<SourceProductType, SourceList> = {
  [SourceProductType.Nmdp]: SourceList.Nmdp,
  [SourceProductType.Bmdw]: SourceList.Wmda,
  [SourceProductType.Bmdwd]: SourceList.Wmda,
  [SourceProductType.Wmda]: SourceList.Wmda,
  [SourceProductType.Coop]: SourceList.Coop,
  [SourceProductType.Mbr]: SourceList.Nmdp,
};

export enum BloodSourceType {
  Donors = 'donors',
  Cords = 'cords',
  Biobanks = 'biobanks',
  Bdps = 'bdps',
}

export enum UppercaseSourceType {
  Donor = 'DONOR',
  Cord = 'CORD',
  Biobank = 'BDP',
}

export const ION_AS_ID_BPTYPES = ['REG', 'BMD', 'CDS', 'BMC', 'CCS'];

export type OrderableSource = OrderableDonor | OrderableCord | OrderableBiobank;

export class SourceOrdersModel<TSource extends OrderableSource> {
  public id: MsApp.Guid;
  public isCord: boolean;
  public isDonor: boolean;
  public expanded: boolean;
  public hasSeveralOrders: boolean;
  public orders: OrderWithTrackingsModel[] = [];

  constructor(
    public source: TSource,
    public vaccination: VaccinationModel = null
  ) {
    this.id = this.source.id;
    this.isCord = SourceTypes.Cord === this.source.type;
    this.isDonor = SourceTypes.Donor === this.source.type;
    this.hasSeveralOrders = this.orders.length > 1;
  }
}

export type SourceBaseOrdersModel = SourceOrdersModel<OrderableSource>;

export type CordOrdersModel = SourceOrdersModel<OrderableCord>;

export type DonorOrdersModel = SourceOrdersModel<OrderableDonor>;

export function isDonorOrders(sourceOrders: SourceBaseOrdersModel): sourceOrders is DonorOrdersModel {
  return sourceOrders.isDonor;
}

export function isCordOrders(sourceOrders: SourceBaseOrdersModel): sourceOrders is CordOrdersModel {
  return sourceOrders.isCord;
}

export interface CaseProgressNoteExtended {
  notes: string;
  sourceGuid?: string;
  subjectGuid?: string;
  updateBy: string;
  updateDate: string;
}
